module.exports = __webpack_public_path__ + "static/media/download.d53bd859.svg";